module.exports = __webpack_public_path__ + "img/combine_cells.7c18ff63.svg";